<template>
    <div v-loading="loading">
        <section class=" bg-white py-4 px-3 rounded-md" >
            <div class=" flex items-center justify-between flex-wrap">
                <p><span class=" text-lg font-semibold">Shipping ID: #{{ shippingTimeline?.raw?.shippingReference ||
                        ""}}</span> <span class=" text-gray-400 text-sm rounded">{{
                            formatDate(shippingTimeline?.raw?.createdAt) }}</span></p>
                <button @click="updateBookingAction" class=" py-2 px-3 bg-primary-yellow rounded mt-2 sm:mt-0">Update
                    Status</button>
            </div>
            <div class=" bg-primary-green text-white px-3 py-4 my-3 flex gap-4 items-center rounded-xl">
                <div>
                    <span class="standard_wrapper">
                        <img src="@/assets/images/ondemand/fluent-arrow.svg" class="img_standard" />
                    </span>
                </div>
                <div>
                    <b>{{ shippingTimeline?.banner?.title || "Standard Shipping" }}</b>
                    <p>{{ shippingTimeline?.banner?.description || "This order has been shipped to the customer" }}</p>
                </div>
            </div>
        </section>

        <section class="bg-white py-4 rounded-xl mt-4 px-3">
            <Timeline :shippingTimeline="shippingTimeline" />
        </section>

        <section class="bg-white py-4 rounded-md mt-4">
            <ShippingInfo :shippingTimeline="shippingTimeline" />
        </section>

        <section>
            <div class="px-0 bg-white rounded-md mt-4  overflow-hidden">
                <p class="text-lg bg-primary-lighterblue py-3 px-3">Order Items</p>
                <table class="custom-table responsive-table border-collapse custom_classs">
                    <thead>
                        <tr class="shadow-md rounded-lg">
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Dimension (Cm)</th>
                            <th>Gross Weight(kg)</th>
                            <th>Total Cost(N)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pack, index) in shippingTimeline?.orderItems" :key="index+'items'" class="shadow-md rounded-lg">
                            <td>{{ pack?.item || 'N.A' }}</td>
                            <td>{{ pack?.quantity || '0' }}</td>
                            <td>{{ pack?.dimension || "" }}</td>
                            <td>{{ pack?.grossWeight }}{{ pack?.package?.unitOfWeight }}</td>
                            <td>{{ amountFomatter(pack?.totalCost) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <update-status-modal @refetchBooking="refetchBooking" :booking="shippingTimeline.raw"
            :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false"
            @booking-subaction-completed="actionCompleted" />
    </div>
</template>

<script>
import ShippingInfo from "./modules/shipping-info.vue";
import UpdateStatusModal from "@/components/3pl/Operations/Bookings/Modals/UpdateStatusModal";
import Timeline from "./modules/timeline.vue";
import moment from "moment"

export default {
    components: {
        ShippingInfo,
        UpdateStatusModal,
        Timeline
    },
    data() {
        return {
            showUpdateStatusModal: false,
            selectedBooking: {},
            shippingTimeline: {},
            loading: true
        }
    },
    mounted() {
        this.getViewTimeline()
    },
    methods: {
        actionCompleted() {
            this.getViewTimeline()
        },
        formatDate(date) {
            return moment(date).format('dddd MMMM D, YYYY, h:mmA')
        },
        async getViewTimeline() {
            this.loading = true
            try {
                const response = await this.$_getNewViewTimeline(this.$route?.params?.id);
                this.shippingTimeline = response.data?.data
            } catch (error) {
                this.handleError(error)
            } finally{
                this.loading = false
            }
        },
        updateBookingAction() {
            this.showUpdateStatusModal = true
        },
        refetchBooking() {

        }
    },
}
</script>

<style lang="scss" scoped>
.standard_wrapper {
    @apply w-[50px] h-[50px] rounded-full bg-white inline-flex justify-center items-center;
}

.img_standard {
    @apply w-[30px] h-[30px]
}

.custom_classs {
    margin: 0 !important;
    @apply mx-3 !w-full;
}
</style>